import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formatPrice } from 'app/util';
import { components, contentfulViews, contentfulModels } from '@glowforge/ui-common';

import './order-details.less';

const { getSectionForPageByIdAndType } = contentfulModels;
const { Markdown } = components;
const { TextAndImageSection } = contentfulViews;

const OrderDetails = (props) => {
  const imageSection = getSectionForPageByIdAndType(props, 'order-summary-glowforge-image', 'textAndImageSection');

  // This makes me feel dirty... but i'm not sure a better way to manage it easily
  let imageIndex = _.findIndex(imageSection.images, { fields: { title: 'BASIC FRONT CLOSED' } });
  if (props.priceSummary.glowforgeName === 'Glowforge Pro') {
    imageIndex = _.findIndex(imageSection.images, { fields: { title: 'PRO FRONT CLOSED' } });
  } else if (props.priceSummary.glowforgeName === 'Glowforge Plus') {
    imageIndex = _.findIndex(imageSection.images, { fields: { title: 'PLUS FRONT CLOSED' } });
  }

  const sectionTitle = _.get(_.find(props.textStrings, { fields: { id: 'order-details-title' } }), 'fields.text');
  const discountLine = props.priceSummary.discountTotal < 0 ? (
    <div className='row'>
      <div className='col'>Discount Total:</div>
      <div className='col'>{formatPrice(props.priceSummary.discountTotal)}</div>
    </div>
  ) : null;
  const supportText = _.get(_.find(props.textStrings, { fields: { id: 'order-details-support' } }), 'fields.text');

  return (
    <div className='OrderDetails fullWidth contentWide'>

      <div className='summary'>
        <h2 className='h2'>{sectionTitle}</h2>

        <div className='breakDown'>
          <h3 className='h3'>Summary</h3>
          <div className='table'>
            <div className='row'>
              <div className='col'>Price before discounts:</div>
              <div className='col'>{formatPrice(props.priceSummary.priceBeforeDiscounts)}</div>
            </div>
            <div className='row'>
              <div className='col'>Items Purchased:</div>
              <div className='col'>{_.join(props.priceSummary.itemsPurchased, ', ')}</div>
            </div>
            <div className='row'>
              <div className='col'>Shipping Cost:</div>
              <div className='col'>{formatPrice(props.priceSummary.shippingCost)}</div>
            </div>
            <div className='row'>
              <div className='col'>Sales Tax:</div>
              <div className='col'>{formatPrice(props.priceSummary.salesTax)}</div>
            </div>
            {discountLine}
            <div className='row totalPaid'>
              <div className='col'>Total Paid:</div>
              <div className='col'>{formatPrice(props.priceSummary.totalPaid)}</div>
            </div>
          </div>
        </div>

        <div className='shippingAddress'>
          <h3 className='h3'>Shipping Address</h3>
          <div>{props.shippingSummary.name}</div>
          <div>{props.shippingSummary.addressLine1}</div>
          <div>{props.shippingSummary.addressLine2}</div>
        </div>

        <div className='orderNumber'>
          <h3 className='h3'>Order Number</h3>
          <div>{props.orderNumber}</div>
        </div>
        <div className='contactInfo'>
          <Markdown source={supportText} />
        </div>
      </div>
      <TextAndImageSection {...imageSection} imageIndex={imageIndex} />

    </div>
  );
};

OrderDetails.propTypes = {
  textStrings: PropTypes.arrayOf(PropTypes.object).isRequired,
  priceSummary: PropTypes.shape({
    priceBeforeDiscounts: PropTypes.number,
    itemsPurchased: PropTypes.arrayOf(PropTypes.string),
    shippingCost: PropTypes.number,
    glowforgeName: PropTypes.string,
    salesTax: PropTypes.number,
    discountTotal: PropTypes.number,
    totalPaid: PropTypes.number,
  }).isRequired,
  shippingSummary: PropTypes.shape({
    name: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
  }).isRequired,
  orderNumber: PropTypes.string.isRequired,
};

export default OrderDetails;



// WEBPACK FOOTER //
// ./app/store/components/glowforge/confirmation/order-details.jsx